import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityRPESubActividadesState } from './rpe-sub-actividades.state';

import {
  entityRPESubActividadesAddFailure,
  entityRPESubActividadesAddRequest,
  entityRPESubActividadesAddSuccess
} from './rpe-sub-actividades.actions';

const reducer = createReducer(
  initialState,
  // add
  on(entityRPESubActividadesAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRPESubActividadesAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRPESubActividadesAddSuccess, (state, { item }) =>
    // Agrego el resultado del post en las demás entidades
    ({
      ...state,
      isLoading: false,
      error: null
    })
  )  
);

export function rpeSubActividadesReducer(
  state: EntityRPESubActividadesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
